export default "__VITE_ASSET__B2idy_ab__"